"use strict";
IREP.BeatTheClock = (function () {

    var options;
    var init = function (initOptions) {
        PointerEventsPolyfill.initialize({});
        options = initOptions;

        $("#startQuiz").one("click", function () {
            TweenMax.to($("#divAvatar"), 0.25, { scale: 1.5 });
            TweenMax.to($("#divAvatar"), 0.25, { scale: 1, delay: .25 });
            $(".gameHeadlineTxt1").fadeOut(500);
            $("#howToPlay").fadeOut(500);
            $("#startQuizWrapper").fadeOut(500, function () {
                $("#quizQuestion").show();
                startQuiz();
            });
        })       

        $(".close").hover( function () {
            $(this).css({ "cursor": "pointer" });
        });
    };

    var startQuiz = function () {
        $(".close").show();

        IREP.BeatTheClock.quiz.init({
            progressText: options.progressText,
            gameOverPromotionTagline: options.gameOverPromotionTagline,
            correct: options.correct,
            playsRemainingText: options.playsRemainingText,
            youLost: options.youLost,
            youWon: options.youWon,
            userStatistics: options.userStatistics,
            totalTime: 60000
        }).done(function (data) {
        });
    };

    return {
        init: init,
    };
})();


IREP.BeatTheClock.quiz = (function () {
    var playsRemaining, userCanPlay = null;

    TweenMax.to($(".main"), 0.5, { scale: 1.4 });
    TweenMax.to($(".main"), 0.5, { scale: 1, delay: .25 });
    $("#startQuizWrapper").fadeIn(700);
    TweenMax.from($("#startQuiz"), .5, { rotationX: "720", delay: 1 });

    var userStatistics, timeLastAnswer = 0, timeThisAnswer, timeTotalAnswerTime = 0, timerElapsed, gameOverPromotionTagline, youLost, playsRemainingText, youWon, quizData, currentQuestionIndex, currentQuestion, numberCorrect, numberWrong, timer, allowedTimePerQuestion, usedTime, results, correct, unanswered;

    var init = function (initOptions) {
        gameOverPromotionTagline = initOptions.gameOverPromotionTagline;
        userStatistics = initOptions.userStatistics;
        correct = initOptions.correct;
        youLost = initOptions.youLost;
        playsRemainingText = initOptions.playsRemainingText;
        youWon = initOptions.youWon;
        allowedTimePerQuestion = initOptions.totalTime;
        timer = new IREP.Countdown({ totalTime: allowedTimePerQuestion, updateTime: 100 });
        usedTime = 0;
        results = [];init

        var data = {
            promotion: {
                Promotion: "BeatTheClock"
            }
        };
        return IREP.callApi({ url: "promotion/start" }).done(function (data) {
            playsRemaining = data.canPlayPromoInfo.availablePlaysRemaining;

            if (data.canPlayPromoInfo != null && data.canPlayPromoInfo.canPlay === true) {
                userCanPlay = true;
                quizData = data.quiz;
                currentQuestionIndex = 0;
                numberCorrect = 0;
                numberWrong = 0;
                timer.start().progress(handleTimerProgress).done(handleTimerRanOut).fail(handleTimerStopped);
                progressBar();
                displayQuestion();
            } else {
                availablePlaysExceeded();
            }
        });
    };

    var availablePlaysExceeded = function (playsRemaining) {
        window.location = "..";
    };

    var showHud = function () {
        $("#hudMain").show();
        $("#ballLogo").show();
        $(".footer").show();
    };

    var progressBar = function () {
        var paginationBlock = null, pagination = quizData.questions;
        $.each(pagination, function (index, question) {
            if (index == 0) {
                paginationBlock = $("<div>").addClass("box grey first").attr({ id: question.questionCode });
            } else {
                paginationBlock = $("<div>").addClass("box grey").attr({ id: question.questionCode });
            }
            $("#progressBar").append(paginationBlock);
        });
    }

    var displayQuestion = function () {
        $("#questionText").fadeIn(500);
        currentQuestion = quizData.questions[currentQuestionIndex++];
        $("#questionText").html(currentQuestion.questionText);
        $("#answers").empty().hide();
        var currentQuestionCode = $('#' + currentQuestion.questionCode);
        currentQuestionCode.addClass("active");

        $.each(currentQuestion.answers, function (index, answer) {
            var answerElement = $("<div>").addClass("answer").attr({ id: answer.answerId }).html(answer.answerText).one("click", handleAnswerSelection);
            $("#answers").append($("<div>").addClass("answerWrapper").append(answerElement));
        });

        $(".answerWrapper").hide();
        $("#answers").fadeIn(500);

        $(function () {
            animateAnswers('.answerWrapper', 250, '1');
        });

        function animateAnswers(e, s, o) {
            var $fade = $(e);
            var code = function () { };
            $fade.each(function (i) {
                $(this).delay(i * s).fadeTo(s, o, code);
            });
        }
    };

    var handleTimerProgress = function (args) {
        var percentage = args.elapsed / allowedTimePerQuestion * 100;
        $("#timerProgress").css({ width: percentage + "%" });
        timerElapsed = args.elapsed;
    };

    var handleTimerRanOut = function (args) {
        unanswered = quizData.questions.splice(results.length, quizData.questions.length - results.length)
        $.each(unanswered, function (i, e) {
            results.push({ questionId: e.questionId, answerId: 0 });
        });
        $("#gameHeadline").css("width", "750px");
        if (unanswered.length >= 5) {
            //IF user fails to answer anything redirect to landing page
            //   window.location = "..";
            looserUser();
        } else {
            postResults();
        }

    };

    var handleTimerStopped = function (args, customArgs) {
        usedTime = args.trueElapsed;
        postResults();
    };

    var handleAnswerSelection = function () {
        if ($(this).parent().css("opacity") != "1") //Check if rendering is complete. 
        {
            $(this).one("click", handleAnswerSelection); //Reinitialize the one click to rule them all; otherwise the next click fails. 
            return; //answer not ready to be selected; 
        }
        timeThisAnswer = timerElapsed;
        var questionTime = (timeThisAnswer - timeLastAnswer);
        timeLastAnswer = timeThisAnswer;
        timeTotalAnswerTime = timeTotalAnswerTime + questionTime;

        $("#questionText").fadeOut(200);
        $("#answers").fadeOut(200);
        $(".answer").off();
        var answerId, selectedAnswerId = (this != null) ? this.id : 0;
        var answer = $.grep(currentQuestion.answers, function (a) {
            return a.answerId == selectedAnswerId;
        });

        var isRight, answerId;
        if (answer != null && answer.length > 0) {
            isRight = answer[0].isCorrectAnswer;
            answerId = answer[0].answerId;
        } else {
            isRight = false;
            answerId = 0;
        }

        results.push({ questionId: currentQuestion.questionId, answerId: answerId, correct: isRight });
        postAnswer(answerId, questionTime);
        if (currentQuestionIndex >= quizData.questions.length) {
            timer.stop();
        } else {
            displayQuestion();
        }
    };

    var postAnswer = function (answerId, answerTime) {
        var data = {
            answerAudit: {
                auditUID: quizData.auditUID,
                answerID: answerId,
                answerTime: answerTime
            }
        };
        IREP.callApi({ url: "promotion/submit/answer", data: data, type: "POST" }).done(function (data) {
        });
    };

    var looserUser = function () {
        var IE8 = $("#browser").hasClass("ie8");
        if (IE8 == true) {
            $("#availablePlaysRemaining").css("top", "58px");
            $("#gameStatButtonPos").css("top", "376px");
        }

        playsRemaining = playsRemaining - 1;
        if (userCanPlay == true & playsRemaining >= 1) {
            $("#playAgain").show();
            $("#availablePlaysRemaining").html(playsRemainingText + " " + playsRemaining).show();
            //$("#availablePlaysRemaining").show();
            $("#backToLanding").show();
        } else {
            $("#playAgain").hide();
            //   $("#availablePlaysExceeded").show();
            $("#gameStatButtonPos").css("right", "350px");
            $("#backToLanding").show();
        }
        $("#questionText").fadeOut();
        $("#quizQuestion").hide();
        $("#gameHeadline").show()
        $("#gameOverStats").attr("id", "gameOverStats-loser");
        $(".gameOverPromotionTagline").css("visibility", "hidden");
        $(".gameHeadlineTxt1").html(youLost).fadeIn(800);
        TweenMax.to($("#divAvatar"), 0.25, { scale: 0, display: "none" });
        TweenMax.to($("#gameStatAvatar"), 0.25, { display: "block", opacity: "1", delay: .254 });
        TweenMax.to($("#gameOver"), 0.5, { display: "block", scale: 1.2 });
        TweenMax.to($("#gameOver"), 0.5, { scale: 1, delay: .25 });
        TweenMax.to($("#gameStatButtonPos"), .5, { display: "block", rotationX: "720", delay: 1 });
        $(".userStatistics").html(userStatistics.replace("@answeredCorrectly@", "0").replace("@numberOfQuestions@ ", "5 ").replace("@elapsedTime@", "60").replace("Correct", correct));
    }


    //End
    var endQuiz = function (data) {
        var IE8 = $("#browser").hasClass("ie8");
        $(".close").hide();
        if (IE8 == true) {
            $("#availablePlaysRemaining").css("top", "58px");
            $("#gameStatButtonPos").css("top", "376px");
        }

        playsRemaining = playsRemaining - 1;
        if (userCanPlay == true & playsRemaining >= 1) {
            $("#playAgain").show();
            $("#availablePlaysRemaining").html(playsRemainingText + " " + playsRemaining).show();
            //$("#availablePlaysRemaining").show();
            $("#backToLanding").show();
        } else {
            $("#playAgain").hide();
            //   $("#availablePlaysExceeded").show();
            $("#gameStatButtonPos").css("right", "350px");
            $("#backToLanding").show();
        }

        $("#questionText").fadeOut();
        $("#quizQuestion").hide();

        $("#gameHeadline").show().css("width", "750px");
        if (data.quizResult.pass === true) {
            $(".gameHeadlineTxt1").html(youWon).fadeIn(800);
            $(".gameOverPromotionTagline").show();

        } else {
            $("#gameOverStats").attr("id", "gameOverStats-loser");
            $(".gameOverPromotionTagline").hide();
            $("#questionText").css("display", "none");
            $(".gameHeadlineTxt1").html(youLost).fadeIn(800);
        }
        TweenMax.to($("#divAvatar"), 0.25, { scale: 0, display: "none" });
        TweenMax.to($("#gameStatAvatar"), 0.25, { display: "block", opacity: "1", delay: .254 });
        TweenMax.to($("#gameOver"), 0.5, { display: "block", scale: 1.2 });
        TweenMax.to($("#gameOver"), 0.5, { scale: 1, delay: .25 });
        TweenMax.to($("#gameStatButtonPos"), .5, { display: "block", rotationX: "720", delay: 1 });

        var //userbonus = "#?- User Bonus ?#",
            userLocation = data.countryCode,
            answerIndex = data.quizResult.answers.length,
            correctAnswers = data.quizResult.answers,
            numberAnsweredCorrectly = 0,
            elapsedTime = timeTotalAnswerTime.toFixed(2);

        $.each(correctAnswers, function (index, correctObj) {
            if (correctObj.correct == true) {
                numberAnsweredCorrectly++;
            }
        });
        $(".userLocation").text(userLocation);
       

        if (typeof unanswered == 'undefined') {
            elapsedTime = (elapsedTime / 1000).toString();
            if (IREP.options.user.cultureCode == "de-DE") {
                elapsedTime = elapsedTime.replace(".", ",");
            }
        }
        else {
            elapsedTime = 60;
        }
        $(".gameOverPromotionTagline").html(gameOverPromotionTagline.replace("[SCORE]", (numberAnsweredCorrectly / answerIndex) * 100).replace("[TIME]", elapsedTime));
        $(".userStatistics").html(userStatistics.replace("@answeredCorrectly@", numberAnsweredCorrectly).replace("@numberOfQuestions@", answerIndex + " ").replace("@elapsedTime@", elapsedTime).replace("Correct", correct));
    };

    var postResults = function () {
        if (typeof unanswered !== 'undefined') {
            usedTime = 60000;
        }
        var data = {
            quizData: {
                activityUID: quizData.activityUID,
                auditUID: quizData.auditUID,
                time: usedTime,
                results: results
            }
        };

        return IREP.callApi({ url: "promotion/submit", data: data, type: "POST" })
        .done(function (data) {
            endQuiz(data);
        });
    };

    return {
        init: init,
        displayQuestion: displayQuestion,
        postResults: postResults,
    };
})();

IREP.BeatTheClock.landing = (function () {
    var promotionCountdownText, promotionEndDate, pageLoadedDateTime, pageLoadedLocalDateTime;
    var init = function (initOptions) {
        $("#trainingBar").click(function () {
            if ($("#arrow").hasClass("right")) {
                $("#arrow").removeClass("right").addClass("down");
                $(".sectionBody").slideDown(1000);
            }
            else {
                $("#arrow").removeClass("down").addClass("right");
                $(".sectionBody").slideUp(1000);
            }
        });

        if (initOptions.canPlay == "False") {
            showNextPlayCountdown();
        }
        if ("LAR|APAC|EMEA".search(IREP.options.user.geoCode) >= 0) {
            promotionCountdownText = $("#promotionCountdownText").html();
            promotionEndDate = new Date(initOptions.promotionEndDate);
            pageLoadedDateTime = new Date(initOptions.pageLoadedDateTime);
            pageLoadedLocalDateTime = new Date();
            ShowPromotionCountdownTimer();
        }
        $("#trainingBar").hover(function () {
            $(this).css({ "cursor": "pointer" });
        });

        //this functionality got cancelled; leave for now
        $("#filterDaily").click(function () {
            if ($("#txtDateTaken").val() == "") return false;
            $("#DailyLeaderboard").empty();
            var params = {
                TimeFrame: 1,
                FromDate: $("#txtDateTaken").val(),
                ToDate: $("#txtDateTaken").val()
            };
            PopulateLeaderboard(params);
        });

        //this functionality got cancelled; leave for now
        $("#filterWeekly").click(function () {
            $("#WeeklyLeaderboard").empty();
            var date = $("#FilterDates").val();

            var params = {
                TimeFrame: 7,
                FromDate: date.substring(0, date.indexOf("-")),
                ToDate: date.substring(date.indexOf("-") + 1)
            };
            PopulateLeaderboard(params)
        });

        //$('#txtDateTaken').on('input', function (e) {
        //});
    };
    //this functionality got cancelled; leave for now
    var PopulateLeaderboard = function (params) {

        IREP.callApi("promotion/genericleaderboard/get", "GET", params).done(function (data) {
            if (data.genericLeaderboard.length > 0)
            {
                var leaderboard;
                if (params.TimeFrame == 1)
                    leaderboard = $("#DailyLeaderboard");
                else
                    leaderboard = $("#WeeklyLeaderboard");
                $.each(data.genericLeaderboard, function (i, item) {
                    var alternate = "";
                    if (i % 2 == 0) { alternate = "alternate"; }
                    var isSelf = "";
                    if (item.isSelf) { isSelf = " isSelf"; }
                    leaderboard.append("<div class='row " + alternate + isSelf + "'><div class='rank'><div>" + item.rank + "</div></div><div class='name'><div>" + item.name + "</div></div><div class='score'><div>" + item.score + "</div></div></div>");
                });
            }
        });
    }

    var timeToNextPlay, dayCutOff = 22;

    var showNextPlayCountdown = function () {
        var d = new Date();
        var d3;

        if (d.getUTCHours() < dayCutOff) {
            var till10 = dayCutOff - d.getUTCHours();
            d3 = new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours() + till10, 0, 0);
        } else {
            var till10 = d.getUTCHours() - dayCutOff
            d3 = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1, d.getHours() - till10, 0, 0);
        }
        timeToNextPlay = Math.abs(d3 - d);

        var timer1 = new IREP.Countdown({ totalTime: timeToNextPlay, updateTime: 1000 });
        timer1.start().progress(handleNextPlayProgress).done(handleNextPlayRanOut).fail(handleNextPlayStopped);
    }

    var handleNextPlayProgress = function (args) {
        var duration = timeToNextPlay - args.elapsed;
        var seconds = parseInt((duration / 1000) % 60)
        , minutes = parseInt((duration / (1000 * 60)) % 60)
        , hours = parseInt((duration / (1000 * 60 * 60)) % 24);

        hours = ((hours < 10) ? "0" + hours : hours).toString();
        minutes = ((minutes < 10) ? "0" + minutes : minutes).toString();
        seconds = ((seconds < 10) ? "0" + seconds : seconds).toString();
        updateClock(hours, minutes, seconds);
    };

    var updateClock = function (hours, minutes, seconds) {
        $("#nextPlayTimer, #launchTimer").find(".hours").find(".left").html(hours[0]);
        $("#nextPlayTimer, #launchTimer").find(".hours").find(".right").html(hours[1]);
        $("#nextPlayTimer, #launchTimer").find(".minutes").find(".left").html(minutes[0]);
        $("#nextPlayTimer, #launchTimer").find(".minutes").find(".right").html(minutes[1]);
        $("#nextPlayTimer, #launchTimer").find(".seconds").find(".left").html(seconds[0]);
        $("#nextPlayTimer, #launchTimer").find(".seconds").find(".right").html(seconds[1]);
    }

    var handleNextPlayRanOut = function (args) {
        window.location.reload();
    };

    var handleNextPlayStopped = function (args, customArgs) {
        window.location.reload();
    };

    var ShowPromotionCountdownTimer = function () {

        getTime();
        var promotionCountdownTimer = setInterval(function () { getTime() }, 60000);
    }

    var getTime = function () {

        var diff = (promotionEndDate - pageLoadedDateTime) / 1000;
        var timeElapsed = getElapsedTime();
        diff = diff - timeElapsed;
        if (diff < 0) {
            clearInterval(promotionCountdownTimer);
            $(".promotionCountdown").css("display", "none");
        }
        diff = Math.abs(Math.floor(diff));

        var days = Math.floor(diff / (24 * 60 * 60));
        var seconds = diff - days * 24 * 60 * 60;

        var hours = Math.floor(seconds / (60 * 60));
        seconds = seconds - hours * 60 * 60;

        var minutes = Math.floor(seconds / (60));
        seconds = seconds - minutes * 60;

        updatePromotionCountdownTimer(days, hours, minutes);
    };

    var getElapsedTime = function () {
        var currentDateTime = new Date();
        return (currentDateTime - pageLoadedLocalDateTime) / 1000;
    }

    var updatePromotionCountdownTimer = function (days, hours, minutes) {
        $("#promotionCountdownText").html(promotionCountdownText.replace("{0}", days).replace("{1}", hours).replace("{2}", minutes));
        $("#promotionCountdownText").css("display", "block");
    }

    return {
        init: init
    };
})();

///*
//* Pointer Events Polyfill: Adds support for the style attribute "pointer-events: none" to browsers without this feature (namely, IE).
//* (c) 2013, Kent Mewhort, licensed under BSD. See LICENSE.txt for details.
//*/

// constructor
function PointerEventsPolyfill(options) {
    // set defaults
    this.options = {
        selector: '*',
        mouseEvents: ['click', 'dblclick', 'mousedown', 'mouseup'],
        usePolyfillIf: function () {
            if (navigator.appName == 'Microsoft Internet Explorer') {
                var agent = navigator.userAgent;
                if (agent.match(/MSIE ([0-9]{1,}[\.0-9]{0,})/) != null) {
                    var version = parseFloat(RegExp.$1);
                    if (version < 11)
                        return true;
                }
            }
            return false;
        }
    };
    if (options) {
        var obj = this;
        $.each(options, function (k, v) {
            obj.options[k] = v;
        });
    }

    if (this.options.usePolyfillIf())
        this.register_mouse_events();
}

// singleton initializer
PointerEventsPolyfill.initialize = function (options) {
    if (PointerEventsPolyfill.singleton == null)
        PointerEventsPolyfill.singleton = new PointerEventsPolyfill(options);
    return PointerEventsPolyfill.singleton;
};

// handle mouse events w/ support for pointer-events: none
PointerEventsPolyfill.prototype.register_mouse_events = function () {
    // register on all elements (and all future elements) matching the selector
    $(document).on(this.options.mouseEvents.join(" "), this.options.selector, function (e) {
        if ($(this).css('pointer-events') == 'none') {
            // peak at the element below
            var origDisplayAttribute = $(this).css('display');
            $(this).css('display', 'none');

            var underneathElem = document.elementFromPoint(e.clientX, e.clientY);

            if (origDisplayAttribute)
                $(this)
                    .css('display', origDisplayAttribute);
            else
                $(this).css('display', '');

            // fire the mouse event on the element below
            e.target = underneathElem;
            $(underneathElem).trigger(e);

            return false;
        }
        return true;
    });
};